import { motion, useAnimation } from "framer-motion";
import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";

import MiceRearScreen from "../MiceRearScreen/MiceRearScreen";
import SnakeCollectionScreen from "../SnakeCollectionScreen/SnakeCollectionScreen";
import SnakeRearScreen from "../SnakeRearScreen/SnakeRearScreen";
import VenomCollImageScreen from "../VenomCollImageScreen/VenomCollImageScreen";
import VenomCollVideoScreen from "../VenomCollVideoScreen/VenomCollVideoScreen";
import VenomPreserveScreen from "../VenomPreserveScreen/VenomPreserveScreen";

const variants = {
  hidden: { opacity: 0, y: 150 },
  visible: { opacity: 1, y: 0 },
};

const Components = ({ serial }) => {
  const control = useAnimation();
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      control.start("visible");
    } else {
      control.start("hidden");
    }
  }, [control, inView]);

  return (
    <motion.div
      className="box"
      ref={ref}
      variants={variants}
      initial="hidden"
      animate={control}
      transition={{ duration: 0.5, delay: 0.25 }}
    >
      {serial === 1 && <SnakeCollectionScreen />}
      {serial === 2 && <SnakeRearScreen />}
      {serial === 3 && <VenomCollImageScreen />}
      {serial === 4 && <VenomCollVideoScreen />}
      {serial === 5 && <VenomPreserveScreen />}
      {serial === 6 && <MiceRearScreen />}
    </motion.div>
  );
};

const WhatDoScreen = () => {
  return (
    <div>
      <Components serial={1} />
      <Components serial={2} />
      <Components serial={3} />
      <Components serial={4} />
      <Components serial={5} />
      <Components serial={6} />
    </div>
  );
};

export default WhatDoScreen;
